import React from "react";
export default function TestimonialCard({ t }) {
  return (
    <div className="rounded-2xl border border-slate-200/70 bg-white p-4 shadow-sm transition hover:border-amber-200/50 hover:shadow-md">
      <div className="flex items-center gap-3">
        <img src={t.avatar} alt="" className="h-11 w-11 rounded-full object-cover ring-2 ring-amber-100/80" />
        <div className="min-w-0">
          <div className="font-sans text-sm font-bold text-slate-900">{t.name}</div>
          <div className="font-sans text-xs font-medium text-slate-500">{t.handle}</div>
        </div>
      </div>
      <p className="mt-3 font-sans text-sm leading-relaxed text-slate-700">{t.text}</p>
    </div>
  );
}
